// extracted by mini-css-extract-plugin
export default {"container":"Commodity_container__F0eyS"};